import $ from "jquery";
import Screen from "@bd-utils/screen";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import TeamConnector from "@bd-utils/team-connector";
import Debriefing from "@bd-utils/debriefing";
import fb from "@bd-core/firebase";
import { getState, subscribe } from "@bd-stores/store";
import GameLogic from "@bd-core/game-logic";

export const ResultPage = () => {
    const isResultPage = $("#result-page").length > 0;
    if (!isResultPage) return false;

    const elms = {
        goToDebrief: "#debrief",
        teamConnector: ".teamconnector",
        debriefing: ".debriefing",
        proceedRestart: ".js-restart-game",
        backBtn: ".js-result-back",
    };

    const renderAfterInitialized = () => {
        let hasRendered = false;

        subscribe(() => {
            const store = getState();
            if (!store.userProgress.isFirebaseInitialized) return;
            if (store.gameProgress.players.length < 1) return;
            if (hasRendered) return;

            hasRendered = true;
            Screen.calculateCoverSize();
            window.screenCalculationFunc = () => Screen.calculateCoverSize();
            $(window).on("resize", () => Screen.calculateCoverSize());
            $(".app__page").addClass("result-loaded");

            /* Initialize Debriefing */
            if ($(elms.debriefing).length) {
                new Debriefing().init();
            }

            /* Initialize Team-connector */
            if ($(elms.teamConnector).length) {
                new TeamConnector().init();
            }
        });
    };

    renderAfterInitialized();
    GameLogic.listenGameProgressChanged();

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame();
    } catch (e) {
        console.error(e);
    }

    let isLoading = false;

    const showAfterGameContent = () => {
        if ($(elms.debriefing).length) {
            $(".resultPage").addClass("is-debriefing");
            return;
        }

        if ($(elms.teamConnector).length) {
            $(elms.teamConnector).addClass("is-active");
            return;
        }
    };

    const restartGame = async (e) => {
        const $this = $(e.currentTarget);
        if (isLoading) return;
        $this.addClass("is-loading");
        isLoading = true;

        const [res] = await bdjs.goAsync(bdapi.post("game/restart-game"));
        const resData = res?.data || {};

        if (resData?.data?.redirect) {
            bdjs.showLoading();
            $(".transitionPage").show();
            setTimeout(
                () => window.location.replace(resData.data.redirect),
                1000,
            );
            return;
        }

        isLoading = false;
        $this.removeClass("is-loading");
    };

    const goToPrevPage = () => {
        $("#result-page").removeClass("is-debriefing");
    };

    $(elms.goToDebrief).on("click", showAfterGameContent);
    $(elms.proceedRestart).on("click", restartGame);
    $(elms.backBtn).on("click", goToPrevPage);
};
